import apiSlice from "./ApiSlice";
import { v4 as uuid } from "uuid";

const deviceId = localStorage.getItem("deviceId") || uuid();

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Login
    getAllAdmin: builder.query({
      providesTags: ["admin"],
      query: (body) => {
        return {
          url: "/admin",
          method: "POST",
          body,
        };
      },
    }),
    login: builder.mutation({
      invalidatesTags: ["admin"],
      query: (body: { email: string; password: string }) => {
        return {
          url: "/admin/login",
          method: "POST",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
      transformResponse: (response: any) => {
        return { ...response, data: { ...response?.data, deviceId } };
      },
    }),
    register: builder.mutation({
      invalidatesTags: ["admin"],
      query: (body) => {
        return {
          url: "/admin/signup",
          method: "POST",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),

    // Get Access Token
    getAccessToken: builder.mutation({
      invalidatesTags: ["admin"],
      query: (body) => {
        return {
          url: "/admin/refresh",
          method: "POST",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),
    // Change Password
    changePassword: builder.mutation({
      invalidatesTags: ["admin"],
      query: (body) => {
        return {
          url: "/admin/change-password",
          method: "PUT",
          headers: {
            "device-id": deviceId,
          },
          body,
        };
      },
    }),
    resetPassword: builder.mutation({
      invalidatesTags: ["admin"],
      query: ({ body, id }) => {
        return {
          url: `/admin/reset-password/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    // delete
    deleteAdmin: builder.mutation({
      invalidatesTags: ["admin"],
      query: (id) => {
        return {
          url: `/admin/${id}`,
          method: "DELETE",
        };
      },
    }),

    // change status
    changeStatusAdminById: builder.mutation({
      invalidatesTags: ["admin"],
      query: ({ body, id }) => {
        return {
          url: `/admin/status-change/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    updateAdmin: builder.mutation({
      invalidatesTags: ["admin"],
      query: ({ body, id }) => {
        return {
          url: `/admin/profile/${id}`,
          method: "PUT",
          body,
        };
      },
    }),
    getSingleAdmin: builder.query({
      providesTags: ["admin"],
      query: ({ id }: { id: string }) => {
        return {
          url: `/admin/${id}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useChangeStatusAdminByIdMutation,
  useDeleteAdminMutation,
  useGetSingleAdminQuery,
  useUpdateAdminMutation,
  useGetAllAdminQuery,
  useLoginMutation,
  useRegisterMutation,
  useResetPasswordMutation,
  useGetAccessTokenMutation,
  useChangePasswordMutation,
} = authApi;
